import { Badge } from "@dropbox/dig-components/badge";
import { AppsFill, AppsLine } from "@dropbox/dig-icons/dist/mjs/assets";
import useConnectors from "@mirage/service-connectors/useConnectors";
import i18n from "@mirage/translations";
import classnames from "classnames";
import styles from "./GlobalNav.module.css";
import { GlobalNavLink } from "./GlobalNavLink";

export function GlobalNavAppsIcon({
  appsLink,
  isExpanded,
  onAppsClick,
  showTooltipForNavLink,
}: {
  appsLink: string;
  isExpanded: boolean;
  onAppsClick: React.MouseEventHandler;
  showTooltipForNavLink: boolean;
}) {
  const { hasExpiredConnections, hasReauthConnections } = useConnectors();
  const hasWarnings = hasExpiredConnections || hasReauthConnections;

  const collapsedWarningBadge = hasWarnings ? (
    <Badge
      variant="alert"
      className={classnames(styles.globalNavBadge, isExpanded && styles.hidden)}
    >
      {"!"}
    </Badge>
  ) : undefined;

  const expandedWarningBadge = hasWarnings ? (
    <Badge
      variant="alert"
      className={classnames(
        styles.globalNavBadge,
        styles.expanded,
        !isExpanded && styles.hidden,
      )}
    >
      {"!"}
    </Badge>
  ) : undefined;

  return (
    <GlobalNavLink
      hasNotificationBadge={hasWarnings}
      iconBadge={collapsedWarningBadge}
      textBadge={expandedWarningBadge}
      label={i18n.t("apps")}
      to={appsLink}
      lineIcon={AppsLine}
      fillIcon={AppsFill}
      navTab="apps"
      onClick={onAppsClick}
      showTooltip={showTooltipForNavLink}
    />
  );
}
